export default {"src":"/_next/static/media/Icon-Queue-Monitor.d048135d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};